export const useLogout = () => {
  if (import.meta.client) {
    localStorage.removeItem('tokens');
    localStorage.removeItem('useUser');
    localStorage.removeItem('ownerStore');
    localStorage.removeItem('parkerStore');
  }

  useTokens().$reset();
  useUser().$reset();
  useCosmo().$reset();

  navigateTo('/');
}
